import { useCallback } from 'react';
import { useUrlFilters } from '@/lib/hooks/useUrlFilters';
import type { LeoFilters } from '../types';

const defaults: LeoFilters = {
  s: undefined,
  type: undefined,
  status: undefined,
  includeArchived: undefined,
  limit: 20,
  page: 0,
};

const numberFields: (keyof LeoFilters)[] = ['limit', 'page'];
const booleanFields: (keyof LeoFilters)[] = ['includeArchived'];

// Case 360° (Stage 8) — URL-synced LEO directory filters (same shape as
// useClientFilters / useMatterFilters).
export function useLeoFilters() {
  const { updateFilter: baseUpdateFilter, ...rest } = useUrlFilters<LeoFilters>({
    defaults,
    numberFields,
    booleanFields,
  });

  // Auto-reset page when any filter other than page or limit changes
  const updateFilter = useCallback(
    <K extends keyof LeoFilters>(key: K, value: LeoFilters[K]) => {
      baseUpdateFilter(key, value, key !== 'page' && key !== 'limit');
    },
    [baseUpdateFilter],
  );

  return { ...rest, updateFilter };
}
